
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 20 20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M4.362 14.675a9.568 9.568 0 012.613-1.41A8.927 8.927 0 0110 12.75c1.054 0 2.062.172 3.025.516a9.567 9.567 0 012.612 1.409 7.086 7.086 0 001.25-2.131A7.186 7.186 0 0017.332 10c0-2.032-.714-3.762-2.142-5.19C13.761 3.38 12.03 2.666 10 2.666c-2.032 0-3.762.714-5.19 2.142C3.38 6.238 2.666 7.97 2.666 10c0 .901.149 1.75.446 2.544a7.086 7.086 0 001.25 2.131zM10 10.917c-.901 0-1.662-.31-2.28-.928-.619-.62-.928-1.38-.928-2.28 0-.902.309-1.662.928-2.28.618-.62 1.379-.929 2.28-.929.901 0 1.661.31 2.28.928.619.619.928 1.379.928 2.28 0 .902-.31 1.662-.928 2.28-.619.62-1.379.929-2.28.929zm0 8.25c-1.268 0-2.46-.24-3.575-.722a9.256 9.256 0 01-2.91-1.96 9.257 9.257 0 01-1.96-2.91A8.926 8.926 0 01.833 10c0-1.268.24-2.46.722-3.575a9.257 9.257 0 011.96-2.91 9.257 9.257 0 012.91-1.96A8.926 8.926 0 0110 .833c1.268 0 2.46.241 3.575.722a9.257 9.257 0 012.91 1.96 9.256 9.256 0 011.96 2.91A8.925 8.925 0 0119.167 10c0 1.268-.241 2.46-.722 3.575a9.256 9.256 0 01-1.96 2.91 9.256 9.256 0 01-2.91 1.96 8.925 8.925 0 01-3.575.722z"}})])
          )
        }
      }
    